import { Link } from 'react-router-dom';
import { prefetchGalleryFolder } from '../../../hooks/useGalleryFolder';
import { GalleryAlbum, galleryRoute, mediaUrl } from '../../../lib/gallery/api';
import { describeAlbum } from '../../../lib/gallery/format';

export type AlbumGridVariant = 'heroes' | 'strips' | 'default';

export interface IAlbumGridProps {
    albums: GalleryAlbum[];
    /**
     * heroes — root (dwa duże + siatka)
     * strips — podkatalog bez zdjęć (wide strips)
     * default — podkatalog ze zdjęciami (równa siatka)
     */
    variant?: AlbumGridVariant;
}

export const AlbumGrid = ({ albums, variant = 'default' }: IAlbumGridProps) => {
    const mod =
        variant === 'heroes' ? ' galeria__albums--heroes' :
        variant === 'strips' ? ' galeria__albums--strips' :
        '';

    return (
        <div className={`galeria__albums${mod}`}>
            {albums.map((album) => (
                <Link
                    key={album.path}
                    to={galleryRoute(album.path)}
                    className="galeria__album"
                    onMouseEnter={() => prefetchGalleryFolder(album.path)}
                    onFocus={() => prefetchGalleryFolder(album.path)}
                >
                    {album.cover ? (
                        <img
                            className="galeria__album-cover"
                            src={mediaUrl(album.cover.path, 'thumb', album.cover.m)}
                            alt=""
                            loading="lazy"
                            decoding="async"
                        />
                    ) : (
                        <span className="galeria__album-placeholder" aria-hidden="true">
                            <svg viewBox="0 0 24 24"><path d="M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2z" /></svg>
                        </span>
                    )}
                    <span className="galeria__album-info">
                        <span className="galeria__album-name">{album.name}</span>
                        <span className="galeria__album-meta">{describeAlbum(album.photoCount, album.albumCount)}</span>
                    </span>
                </Link>
            ))}
        </div>
    );
};
